import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import HelpDetails from "./HelpDetails";
import { useTranslation } from "react-i18next";

const Help = () => {
  const { t, i18n } = useTranslation();

  const questions = [
    {
      category: "Order",
      question: "주문 내역은 어떻게 확인할 수 있나요?",
      answer:
        "우측 상단 사람 아이콘을 클릭 후 [나의쇼핑] 메뉴를 누르시면 페이지로 이동합니다.",
    },
    {
      category: "Order",
      question: "결제 방법은 어떤 것이 있나요?",
      answer: "신용카드 및 체크카드, 무통장 입금 이용해 결제 가능합니다.",
    },
    {
      category: "Order",
      question: "비회원주문 및 전화주문이 가능한가요?",
      answer:
        "사이트 에서 비회원 주문이 가능합니다. 로그인 없이 물건을 구입하실수 있습니다.",
    },
    {
      category: "Order",
      question: "신용카드 무이자 할부가 되나요?",
      answer: "각 카드사 별로 상이하며, 카드사를 통해 확인 가능합니다.",
    },
    {
      category: "Order",
      question: "신용카드 결제 후 할부 개월 수를 변경 가능한가요?",
      answer:
        "결제 후 결제 정보 변경은 불가능 합니다. 단, 결제 완료 단계에서는 취소 후 재주문을 통해 변경 가능합니다.",
    },
    {
      category: "Order",
      question: "가상계좌 은행을 변경 할 수 있나요?",
      answer:
        "한번 발급 받은 계좌번호는 변경이 불가능합니다. <br />재주문을 통해 새로운 계좌를 발급 받으신 후 입금 부탁드립니다.",
    },
    {
      category: "Order",
      question: "주문 후 결제 방법을 변경하고 싶은데 어떻게 해야 하나요?",
      answer:
        "결제 후 결제 정보 변경은 불가능 합니다. 주문 취소를 요청하시고 재주문을 하실수 있습니다. 입금 대기 및 결제 완료 단계에서는 취소 후 재주문을 통해 변경 가능합니다.",
    },
    {
      category: "Order",
      question: "결제 시 에러 메시지가 나오는 경우 해야하나요?",
      answer: "저희 고객 센터로 연락 주시면 신속하게 답해 드리겠습니다.",
    },
    {
      category: "Order",
      question: "신용카드 안전결제(ISP)는 무엇인가요?",
      answer:
        "국민카드, BC카드는 인터넷 안전결제(ISP)로 결제가 진행됩니다. <br />결제진행시 나타나는 안내에 따라 결제하실 카드번호와 사용하시는 이메일 및 비밀번호를 입력하여 인터넷 안전결제(ISP)등록 후 결제를 진행해 주시면 됩니다. <br />단, 30만원 이상 결제 시에는 공인인증서가 필요합니다.",
    },
    {
      category: "Order",
      question: "가상계좌 입금은 언제 확인 되나요?",
      answer:
        "입금 후 24시간 이내에 확인됩니다.<br />24시간 이후에도 입금확인이 되지 않는 경우 결제 금액과 입금한 금액이 같은지, 올바른 계좌로 입금하였는지 확인 후 헤즐릿 고객 센터를 통해 문의 부탁드립니다.",
    },
    {
      category: "Order",
      question: "가상계좌 입금인을 다르게 적은경우 어떻게 해야하나요?",
      answer: "입금인이 달라도 가상계좌번호만 같으면 문제없습니다.",
    },
    {
      category: "Shipping",
      question: "배송비는 얼마인가요?",
      answer:
        "5만원 이하의 운송비는 5000원이며 5만원 이상의 주문은 무료배송입니다.",
    },
    {
      category: "Shipping",
      question: "배송확인은 어떻게 하나요?",
      answer:
        "헤즐릿에서 보내드린 이메일 안에 송장 번호가 있습니다. 번호를 클릭하시면 배송 상태를 확인 하실 수 있습니다.",
    },
    {
      category: "Shipping",
      question: "배송은 얼마나 걸리나요?",
      answer:
        "상품 배송 기간은 배송 유형에 따라 출고 일자 차이가 있습니다.<br />∙ 일반 택배 / 화물 택배 : 결제 후 1~3 영업일 이내 출고됩니다.<br />※ 영업일은 주말, 공휴일을 제외한 기간입니다.",
    },
    {
      category: "Shipping",
      question: "원하는 날짜로 맞춰서 배송을 받을수 있나요?",
      answer: "고객 센터에 문의 해주세요.",
    },
    {
      category: "Shipping",
      question:
        "배송 시작 이메일을 받았는데, 배송추적이 되지 않습니다. 어떻게 해야하나요?",
      answer:
        "송장번호 등록 후 1영업일 이내 또는 실제 상품배송이 진행됨과 동시에 배송추적이 가능합니다.<br />※ 배송처에서 배송이 시작되기 전, 송장을 먼저 출력 후 송장번호를 입력하는 경우가 있습니다.",
    },
    {
      category: "Shipping",
      question:
        "배송조회를 해보면 배송완료로 확인되는데 택배를 받지 못했습니다. 어떻게 해아하나요?",
      answer:
        "경비실 또는 무인택배함을 먼저 확인 부탁드립니다.<br />별도의 위탁 장소가 없는 경우 배송기사님께서 임의의 장소에 보관하셨을 수 있으니, 기사님께 문의 부탁드립니다.",
    },
    {
      category: "Shipping",
      question: "해외배송이 가능한가요?",
      answer: "미국에서 주문/배송을 준비 중 입니다.",
    },
    {
      category: "Return",
      question: "제품이 불량입니다. 반품 혹은 교환은 어떻게 하나요?",
      answer: "저희 고객센터에 연락주시면 반품/교환 절차를 진행할 수 있습니다.",
    },
    {
      category: "Return",
      question: "제품의 교환 또는 반품을 할 수 있나요?",
      answer:
        "상품을 수령하신 후 7일 이내에 교환, 반품이 가능하며, 고객님의 변심에 의한 교환/반품의 경우 배송비용이 부과될 수 있습니다.<br />※ 단, 아래의 경우 교환/반품이 불가능합니다.<br />- 고객님의 책임 사유로 인해 상품 등이 멸실 또는 훼손된 경우<br />- 개봉 및 포장이 훼손으로 상품가치가 현저히 상실된 경우<br />- 시간 경과에 의해 재판매가 어려울정도로 상품 가치가 현저히 저하된 경우<br />- 고객주문 확인 후 상품제작에 들어가는 주문 제작 상품",
    },
    {
      category: "Return",
      question: "주문한 것과 다른 상품이 왔습니다. 어떻게 해아하나요?",
      answer: "고객 센터에 문의 주시면 도움드리겠습니다.",
    },

    {
      category: "FAQ_Login",
      question:
        "헤즐릿에 가입한 적이 없는데 이미 가입된 이메일이라고 나와요. 어떻게 하나요?",
      answer:
        "이메일을 잘못 입력하신 경우 '이미 가입한 이메일'이라는 알람을 받으실 수 있습니다. <br />고객님의 정보가 노출된 것이 아니니 걱정하지 마시고, 번거로우시겠지만 고객센터로 문의 부탁드립니다.",
    },
    {
      category: "FAQ_Login",
      question: "비밀번호 변경은 어떻게하나요?",
      answer:
        "우측 사람 모양 아이콘을 누르신후 메뉴에서 [비밀번호 변경하기]를 누르시고 변경하시면 됩니다.",
    },
    {
      category: "FAQ_Login",
      question: "회원정보를 수정하고 싶은데 어떻게 해야하나요?",
      answer:
        "우측 사람 모양 아이콘을 누르신후 메뉴에서 [내 정보]를 누르시고 변경하시면 됩니다.",
    },
    {
      category: "FAQ_Login",
      question: "이메일로 헤즐릿의 최신 정보나 뉴스를 받아 보고 싶어요.",
      answer:
        "홈페이지를 밑으로 스크롤 다운 하시면 이메일을 입력할 수 있는 입력창이 있습니다. 그곳에 고객님의 이메일을 넣으면 됩니다.",
    },
    {
      category: "etc",
      question: "오늘의집을 PC나 맥에서도 볼수 있나요?",
      answer:
        "가능합니다. PC나 맥 컴퓨터에서 보실수 있습니다. 또한 핸드폰의 웹브라우저에서도 홈페이지를 보실수 있고 결제도 가능합니다.",
    },
    {
      category: "etc",
      question: "상담방법과 상담가능시간 유선번호는 어떻게 되나요?",
      answer:
        "상담 시간은 평일 09:00 ~ 18:00 (주말 & 공휴일 제외)이며, 전화번호는 1670-0876 입니다.",
    },
    {
      category: "etc",
      question: "B2B 비지니스 문의가 가능한가요?",
      answer:
        "가능합니다. 헤즐릿의 고객센터로 연락주시면 상담 해 드리겠습니다.",
    },
    {
      category: "etc",
      question:
        "제가 쓴 리뷰가 블라인드 처리되었어요, 블라인드 처리 기준은 무엇인가요?",
      answer:
        "헤즐릿은 제품에 대한 유저들이 생생하고 진실된 리뷰를 올리는 문화를 만들어가고자 합니다. 허위나 과장 된 리뷰 그리고 부적절한 리뷰는 블라인드 처리 될 수 있다는 점을 알려드립니다.",
    },
  ];
  const [word, setWord] = useState("");
  const [show, setShow] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [detailQuestion, setDetailQuestion] = useState(null);
  const [detailAnswer, setDetailAnswer] = useState(null);

  const handleDetail = (question, answer) => {
    setShowDetail(true);
    setDetailQuestion((old) => question);
    setDetailAnswer((old) => answer);
  };

  // console.log(answers);
  useEffect(() => {
    console.log("show", show);
  }, [show]);
  useEffect(() => {
    setShow(questions);
  }, []);

  const search = (value) => {
    setShowDetail(false);
    setWord((previousState) => value);
    console.log("----------");
    console.log("value >>>", value);
    setShow(questions);

    if (value?.length > 0) {
      let result = arraySearch(questions, value);
      setShow((old) => result);
    }
  };

  const truncate = (str, n) => {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  };
  const arraySearch = (array, keyword) => {
    const searchTerm = keyword.toLowerCase();
    return array.filter((value) => {
      return value.question.toLowerCase().match(new RegExp(searchTerm, "g"));
    });
  };
  const goBackHandler = () => {
    setShowDetail((old) => false);
  };

  return (
    <Box>
      <Box sx={{ px: 3, pt: 2 }}>
        <TextField
          sx={{ width: 1 }}
          id="filled-basic"
          label={t("Search your question")}
          variant="filled"
          value={word}
          onChange={(e) => search(e.target.value.toLowerCase())}
        />
      </Box>
      <Box
        sx={{
          px: 3,
          overflow: "scroll",
          position: "relative",
          paddingBottom: "120px",
          height: "600px",
        }}
      >
        <Box sx={{ py: 2 }}>{t("Search Results")}</Box>
        {showDetail ? (
          <HelpDetails
            question={detailQuestion}
            answer={detailAnswer}
            goBackHandler={goBackHandler}
          />
        ) : null}

        {!showDetail &&
          show?.map((q) => (
            <Box
              sx={{
                borderBottom: "1px solid lightgray",
                pb: 2,
                cursor: "pointer",
              }}
              onClick={(e) => handleDetail(q.question, q.answer)}
            >
              <Box
                sx={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  pb: 2,
                  pt: 3,
                  color: "#455a64",
                }}
              >
                <Box
                  sx={{ lineHeight: "190%" }}
                  dangerouslySetInnerHTML={{ __html: q.question }}
                />
              </Box>
              <Box>
                <Box
                  sx={{ lineHeight: "190%" }}
                  dangerouslySetInnerHTML={{ __html: truncate(q.answer, 30) }}
                />
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default Help;
